<div [@slideInFromRight]="true" class="snackbar">
  <img
    *ngIf="data?.success"
    src="assets/icon/success.svg"
    alt="Image"
    class="success-img me-2"
  />
  <img
    *ngIf="!data?.success"
    src="assets/icon/quotes_cross.svg"
    alt="Image"
    class="success-img me-2"
  />

  <span>{{ data.message }}</span>
</div>
<div  class="res-snackbar">
  <img
    *ngIf="data?.success"
    src="assets/icon/success.svg"
    alt="Image"
    class="success-img me-2"
  />
  <img
    *ngIf="!data?.success"
    src="assets/icon/quotes_cross.svg"
    alt="Image"
    class="success-img me-2"
  />

  <span>{{ data.message }}</span>
</div>